<template>
  <div>
    <div class="area-text">{{this.row.customer.areaType ||'--'}}</div>
    <div class="ship-text">{{getShipName}}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ColumnShippingType',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      getShipTypeName: 'getShipTypeName'
    }),
    getShipName () {
      return this.getShipTypeName(this.row.shipType)
    }
  }
}
</script>

<style lang="scss" scoped>
.area-text {
  font-size: 11px;
  font-weight: bold;
  color: #616161;
  margin-top: 2px;
}
.ship-text {
  font-style: italic;
  font-size: 11px;
  color: #797979;
  margin-bottom: 2px;
}
</style>
